export default {
  colors: {
    primary: '#4589FF',
    surface: '#151618',
    accent: '#4589FF',
    'accent-fill': '#072643',
    'accent-text': '#FFFFFF',
    'accent-selection-background': '#262F3E',
    'canvas-actions': '#242424',
    'canvas-background': '#1B1D21',
    'canvas-edit-outline': '#2973F3',
    'canvas-outline': '#303135',
    'navigation-background': '#151618',
    'panel-background-secondary': '#1B1D21',
    'panel-background': '#232529',
    'panel-background-tertiary': '#5E5D5F',
    'panel-outline': '#424347',
    'text-canvas-primary': '#FFFFFF',
    'text-canvas-secondary': '#A6A6A6',
    'text-navigation-primary': '#FFFFFF',
    'text-navigation-secondary': '#CECFD2',
    'text-panel-primary': '#FFFFFF',
    'text-panel-secondary': '#CECFD2',
    'text-panel-tertiary': '#A4A6AD'
  }
}
